var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixelarticonsSectionPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H5V5H3V3ZM7 3H9V5H7V3ZM9 19H7V21H9V19ZM11 19H13V21H11V19ZM5 7H3V9H5V7ZM19 7H21V9H19V7ZM21 11H19V13H21V11ZM3 11H5V13H3V11ZM5 15H3V17H5V15ZM17 15H19V17H21V19H19V21H17V19H15V17H17V15ZM5 19H3V21H5V19ZM11 3H13V5H11V3ZM17 3H15V5H17V3ZM21 3H19V5H21V3Z",
    fill: "#8C9FB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelarticonsSectionPlus);
export default __webpack_public_path__ + "static/media/pixelarticons_section-plus.6451fde58cfbab93cb078cf7a852b161.svg";
export { ForwardRef as ReactComponent };